import React from "react";
import { useNavigate } from "react-router-dom";
import { User } from "hooks/useUsers";
import { SkeletonTableRows } from "components/shared/SkeletonTableRows";
import {
  UsersContainer,
  UserRow,
  UserCell,
  TableHeader,
  StatusBadge,
  RoleBadge,
  ResponsiveTableWrapper,
  DeviceLink,
} from "styles/components/usersList.styles";
import { buildDeviceDetailsPath } from "utils/deviceNavigation";

interface UsersTableViewProps {
  users: User[];
  isLoading: boolean;
}

const UsersTableView: React.FC<UsersTableViewProps> = ({
  users,
  isLoading,
}) => {
  const navigate = useNavigate();

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString("en-AU", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const handleDeviceClick = (serialNumber: string) => {
    navigate(buildDeviceDetailsPath({ serialNumber, isAdminView: true }));
  };

  const handleUserClick = (userId: number) => {
    navigate(`/users/${userId}`);
  };

  return (
    <ResponsiveTableWrapper>
      <UsersContainer>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <TableHeader>Name</TableHeader>
              <TableHeader>Email</TableHeader>
              <TableHeader>Role</TableHeader>
              <TableHeader>Device</TableHeader>
              <TableHeader>Verified</TableHeader>
              <TableHeader>Status</TableHeader>
              <TableHeader>Updated At</TableHeader>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <SkeletonTableRows rows={5} columns={7} />
            ) : (
              users.map((user: User) => (
                <UserRow key={user.id} onClick={() => handleUserClick(user.id)}>
                  <UserCell>
                    {user.firstname} {user.lastname}
                  </UserCell>
                  <UserCell>{user.email}</UserCell>
                  <UserCell>
                    <RoleBadge role={user.privledgelevel}>
                      {user.privledgelevel?.toLowerCase() || "user"}
                    </RoleBadge>
                  </UserCell>
                  <UserCell>
                    {user.Device?.serialNumber ? (
                      <DeviceLink
                        onClick={(e: React.MouseEvent) => {
                          e.stopPropagation();
                          handleDeviceClick(user.Device!.serialNumber);
                        }}
                      >
                        {user.Device.serialNumber}
                      </DeviceLink>
                    ) : (
                      "-"
                    )}
                  </UserCell>
                  <UserCell>
                    <StatusBadge
                      status={user.isVerified ? "active" : "inactive"}
                    >
                      {user.isVerified ? "Verified" : "Unverified"}
                    </StatusBadge>
                  </UserCell>
                  <UserCell>
                    <StatusBadge
                      status={user.isdisabled ? "disabled" : "active"}
                    >
                      {user.isdisabled ? "Disabled" : "Active"}
                    </StatusBadge>
                  </UserCell>
                  <UserCell>{formatDate(user.updatedAt)}</UserCell>
                </UserRow>
              ))
            )}
          </tbody>
        </table>
      </UsersContainer>
    </ResponsiveTableWrapper>
  );
};

export default UsersTableView;
